import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getArea = (networkDeviceId) => {
    return axios.get(`/api/DaliHelvarArea/getlist/${networkDeviceId}`, { headers: authHeader() })
        .then(res => {return res.data});
};

const getAreaById = (areaId) => {
    return axios.get(`/api/DaliHelvarArea/getById/${areaId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const createArea = (areaModel) => {
    delete areaModel['id'];
    return axios.post(`/api/DaliHelvarArea/`, areaModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const editArea = (areaModel) => {
    return axios.patch(`/api/DaliHelvarArea/${areaModel.id}`, areaModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const deleteArea = (areaId) => {
    return axios.delete(`/api/DaliHelvarArea/${areaId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const getGroups = (networkDeviceId) => {
    return axios.get(`/api/DaliHelvarGroups/getlist/${networkDeviceId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};

const createGroup = (groupModel) => {
    delete groupModel['id'];
    return axios.post(`/api/DaliHelvarGroups/`, groupModel, { headers: authHeader() })
        .then(res => { return res.data });
};

const editGroup = (groupModel) => {
    return axios.patch(`/api/DaliHelvarGroups/${groupModel.id}`, groupModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const deleteGroup = (groupId) => {
    return axios.delete(`/api/DaliHelvarGroups/${groupId}`, { headers: authHeader() })
        .then(res=> { return res.data })
};

const getGroupById = (helvarGroupId) => {
    return axios.get(`/api/DaliHelvarGroups/GetById/${helvarGroupId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const getScenes = (helvarGroupId) => {
    return axios.get(`/api/DaliHelvarScenes/getlist/${helvarGroupId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};

const createScene = (sceneModel) => {
    delete sceneModel["id"];
    return axios.post(`/api/DaliHelvarScenes`, sceneModel, { headers: authHeader() } )
        .then(res => { return res.data })
};

const editScene = (sceneModel) => {
    return axios.patch(`/api/DaliHelvarScenes/${sceneModel.id}`, sceneModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const deleteScene = (sceneId) => {
    return axios.delete(`/api/DaliHelvarScenes/${sceneId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

export const daliHelvarService = {
    // lists
    getArea,
    getAreaById,
    getGroups,
    getGroupById,
    getScenes,
    // creates
    createArea,
    createGroup,
    createScene,
    // updates
    editArea,
    editGroup,
    editScene,
    // delete
    deleteArea,
    deleteGroup,
    deleteScene,
};
